<template>
  <div class="columns is-gapless" :class="((index % 2) === 0) ? 'is-flex-direction-row-reverse': ''" v-for="(item, index) in CONTENTS" :key="index">
    <div class="column">
      <figure class="image">
        <img class="object-fit-contain" :src="item.src" :alt="item.alt">
      </figure>
    </div>
    <div class="column has-background-white">
      <div class="content px-6 p-6-mobile">
        <p class="has-text-theme-green is-size-7 has-text-weight-bold mb-2">{{item.caption}}</p>
        <p class="title is-3 lh-6" v-html="item.title"></p>
        <p class="title is-5" v-html="item.subtitle"></p>
        <p class="is-size-6 lh-4_3" v-html="item.text"></p>
      </div>
    </div>
  </div>
</template>

<script>
//import config from './../config.json';

const CONTENTS = [
  {
    "src": "./static_img/img01-02.png",
    "alt": "私たちの想い",
    "caption": "私たちの想い",
    "title": "木のチカラで人々を幸せに。",
    "subtitle": "大阪で育った”ほんものの木”と”地元の子どもたち”をつないできました。",
    "text": "私たちは先人たちが残してくれた大阪の森林からの贈り物でもある ”ほんものの木” を子育て施設さまにお届けしています。<br>ほんものの木は子どもたちに”つながり”を与えてくれる資源です。<br>ほんものの木をお届けすることで、子育て施設さまで過ごす子どもたちに『木とふれあう環境』を創り”ほんものの木”と”地元の子どもたち”をつないでいきたいと想っています。",
  }
];

export default {
  name: 'parts-about-us',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    CONTENTS() {
      return CONTENTS;
    }
  }
}
</script>

<style scoped>
</style>
